import { ref, watch, type Ref } from 'vue'
import { useRoute } from 'vue-router'

export function usePreviewMode(fileName: Ref<string | undefined>) {
  const route = useRoute()
  const isOpen = ref(false)

  watch(
    () => route.query.preview,
    (val) => {
      isOpen.value = val === 'open'
    },
    { immediate: true }
  )

  const toggle = () => {
    isOpen.value = !isOpen.value

    const url = new URL(window.location.href)

    if (isOpen.value) {
      url.searchParams.set('preview', 'open')
    } else {
      url.searchParams.delete('preview')
    }

    window.history.pushState(history.state, '', url.toString())
  }

  const pageTitle = (base: string | undefined) => {
    if (!base) return 'Dacr'
    return isOpen.value ? base : `${base} - Dacr`
  }

  return { isOpen, toggle, pageTitle }
}
